// ZoomHandler.js
import * as THREE from 'three';

// Utility to calculate the distance between two touch points for pinch gestures
const getPinchDist = (touches) => {
  const dx = touches[0].pageX - touches[1].pageX;
  const dy = touches[0].pageY - touches[1].pageY;
  return Math.sqrt(dx * dx + dy * dy);
};

// Setup zoom event handlers
export const setupZoomHandlers = ({ camera, renderer, onInteractionStart, onInteractionEnd }) => {
  // Zoom configuration
  const minFov = 70; // Maximum zoom in
  const maxFov = 100; // Maximum zoom out
  const zoomSensitivity = 0.05; // Sensitivity for both wheel and pinch
  let isPinching = false;
  let prevPinchDist = null;

  // Handle mouse wheel for desktop zoom
  const onWheel = (event) => {
    event.preventDefault();
    onInteractionStart();
    const delta = event.deltaY * zoomSensitivity; // Positive deltaY zooms out
    camera.fov = THREE.MathUtils.clamp(camera.fov + delta, minFov, maxFov);
    camera.updateProjectionMatrix();
    onInteractionEnd(); // Wheel events are discrete
  };

  // Handle touch start for pinch zoom (mobile)
  const onTouchStartZoom = (event) => {
    if (event.touches.length === 2) {
      event.preventDefault();
      event.stopImmediatePropagation(); // Prevent rotation handlers from interfering
      isPinching = true;
      prevPinchDist = getPinchDist(event.touches);
      onInteractionStart();
    }
  };

  // Handle touch move for pinch zoom
  const onTouchMoveZoom = (event) => {
    if (isPinching && event.touches.length === 2) {
      event.preventDefault();
      event.stopImmediatePropagation(); // Prevent rotation handlers
      const currentDist = getPinchDist(event.touches);
      const delta = (prevPinchDist - currentDist) * zoomSensitivity; // Positive delta zooms out
      camera.fov = THREE.MathUtils.clamp(camera.fov + delta, minFov, maxFov);
      camera.updateProjectionMatrix();
      prevPinchDist = currentDist;
    }
  };

  // Handle touch end for pinch zoom
  const onTouchEndZoom = (event) => {
    if (event.touches.length < 2) {
      if (isPinching) {
        event.preventDefault();
        event.stopImmediatePropagation(); // Prevent rotation handlers
      }
      isPinching = false;
      prevPinchDist = null;
      onInteractionEnd();
    }
  };

  // Add event listeners
  document.addEventListener('touchstart', onTouchStartZoom, { passive: false });
  document.addEventListener('touchmove', onTouchMoveZoom, { passive: false });
  document.addEventListener('touchend', onTouchEndZoom, false);
  renderer.domElement.addEventListener('wheel', onWheel, { passive: false });

  // Return cleanup function
  return () => {
    document.removeEventListener('touchstart', onTouchStartZoom);
    document.removeEventListener('touchmove', onTouchMoveZoom);
    document.removeEventListener('touchend', onTouchEndZoom);
    renderer.domElement.removeEventListener('wheel', onWheel);
  };
};